import React from 'react';
import styled from 'styled-components';
import { Image } from 'components/Shared';
import { convertHexToRGBA } from 'utils/color';
const Container = styled.div `
  width: 88%;
  border-radius: ${({ theme }) => theme.borderRadius};
  margin: 16px;
  cursor: pointer;
  background: #fff;

  :last-child {
    margin-bottom: 16px;
  }

  ${({ active, theme }) => active &&
    `
    transform: translate(-5px, -10px);
    width: 92%;
    box-shadow: ${theme.shadows[0]};
  `}
`;
const BackgroundContainer = styled.div `
  width: 100%;
  height: 100%;
  background-color: ${({ theme, active }) => active ? convertHexToRGBA(theme.palette.primary.main, 0.2) : '#fff'};
  border-radius: ${({ theme }) => theme.borderRadius};
`;
const ProductImage = styled(Image) `
  height: ${({ active }) => (active ? '100px' : '90px')};
  width: 100%;
  padding: 16px 0 0;
  display: flex;
  margin: auto;

  img {
    width: auto;
    max-width: 90%;
    margin: auto;
    object-fit: contain;
    border-radius: 4px;
  }
`;
const ProductName = styled.div `
  font-size: 14px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ active, theme }) => active ? theme.palette.primary.main : theme.palette.grey['A300']};
`;
const TitleContainer = styled.div `
  padding: 8px;
`;
const SliderItem = ({ image, title, onClick, active }) => {
    return (React.createElement(Container, { active: active, onClick: onClick },
        React.createElement(BackgroundContainer, { active: active },
            React.createElement(ProductImage, { active: active, image: image }),
            React.createElement(TitleContainer, null,
                React.createElement(ProductName, { active: active }, title)))));
};
export default SliderItem;
